export default {
	unreadCount: 0
};
